import React, { useEffect } from 'react';
import { IonLoading, IonRouterOutlet } from '@ionic/react';
import { Toaster } from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import {
  Route, useHistory, Redirect, Switch,
} from 'react-router-dom';
import { appRoutes } from './routes/appRoutes';
import ProtectedRoute from './components/ProtectedRoute';
import { sessionSelector, clearInitialLocation } from './redux/slices/session';
import { StoreProvider } from './providers/store-provider';
import { useAuthContext } from './providers/auth-provider';

const App = () => {
  const history = useHistory();
  const { isLoading } = useAuthContext();
  const { initialLocation } = useSelector(sessionSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (initialLocation.path && initialLocation.pending) {
      dispatch(clearInitialLocation());
      history.replace(initialLocation.path);
    }
  }, [initialLocation]);

  return (
    <StoreProvider>
      <IonLoading isOpen={isLoading} message="Loading..." cssClass="ion-loading-custom" />
      <IonRouterOutlet>
        <Switch>
          {appRoutes.map(({ path, component: Component, protected: isProtected }) => (isProtected ? (
            <ProtectedRoute key={path} exact path={path} component={Component} />
          ) : (
            <Route key={path} exact path={path} component={Component} />
          )))}
          <Redirect to="/tabs/feed" />
        </Switch>
      </IonRouterOutlet>

      <Toaster
        containerStyle={{ top: 60, zIndex: '9999 !important' }}
        toastOptions={{ className: 'toaster', style: { zIndex: '9999 !important' } }}
      />
    </StoreProvider>
  );
};

export default App;
